__turbopack_context__.v({
  "label": "user-menu-module-scss-module__n_cRzG__label",
  "link": "user-menu-module-scss-module__n_cRzG__link",
  "root": "user-menu-module-scss-module__n_cRzG__root",
  "separator": "user-menu-module-scss-module__n_cRzG__separator",
});
